import { getFromDataPath, mutateByPath, reduceDataPath } from "../../../utility";
import { ARSTActionContextmenuAction, ArsTableCellType, ArsTableState } from "../interface";
import { isArsTableSubGroup } from "../typeguards/isArsTableSubGroup";

/**
 * Toggles the hidden flag for a row or column group label target.
 *
 * @param state - Current ARS table state
 * @param action - Context-menu action describing the group label cell to toggle
 * @returns Updated ARS table state
 */
export const arst_toggleGroupLabelVisibility = <T>(
  state: ArsTableState<T>,
  action: ARSTActionContextmenuAction<T>,
): ArsTableState<T> => {
  if (
    action.cellValue.cellType !== ArsTableCellType.ColumnGroupCell &&
    action.cellValue.cellType !== ArsTableCellType.ColumnGroupLabel &&
    action.cellValue.cellType !== ArsTableCellType.RowGroupCell &&
    action.cellValue.cellType !== ArsTableCellType.RowGroupLabel
  ) {
    return state;
  }

  const targetGroupingFactorPath = ["group", "dataDriven"].includes(action.cellValue.targetType)
    ? reduceDataPath(action.cellValue.dataPath, 2)
    : action.cellValue.dataPath;
  const targetItem = getFromDataPath(targetGroupingFactorPath, state.bodyData, (obj) =>
    isArsTableSubGroup(obj, state.settings.editorProps.isT),
  );
  const newValue = !targetItem?.hidden;
  const newBodyData = mutateByPath(state.bodyData, `${targetGroupingFactorPath}/hidden`, newValue);

  if (
    action.cellValue.cellType === ArsTableCellType.RowGroupCell ||
    action.cellValue.cellType === ArsTableCellType.RowGroupLabel
  ) {
    if (newValue === true) {
      newBodyData.rowHeaders.splice(
        action.cellValue.columnIndex -
          (action.cellValue.cellType === ArsTableCellType.RowGroupLabel ? 1 : 0),
        1,
      );
    } else {
      newBodyData.rowHeaders.splice(action.cellValue.columnIndex, 0, {
        heights: [],
        label: state.settings.editorProps.blankT,
        width: 120,
      });
    }
  }

  return {
    ...state,
    bodyData: newBodyData,
    changed: true,
  };
};
